import { types } from 'mobx-state-tree';
import { SavedTabActions } from './Actions/index';
import ListDetails from './ListDetails';
import SavedTabViews from './Views';
const ModelProps = {
    selectedList: types.optional(types.string, 'all'),
    allLists: types.optional(types.array(ListDetails), []),
    pipelineTables: types.optional(types.array(ListDetails), []),
    isPipelineTablesLoaded: types.optional(types.boolean, false),
    /** Ordered `state.contacts` keys of the contacts in the selected list. */
    savedContactIds: types.optional(types.array(types.string), []),
    selectedContactId: types.maybe(types.string),
    isFetchingContacts: types.optional(types.boolean, false),
    refetchAllUserLists: types.optional(types.boolean, false),
    initializeState: types.optional(types.boolean, false),
    shouldFetchContactsAfterBulkSearch: types.optional(types.boolean, false),
    isLoaded: types.optional(types.boolean, false),
};
const SavedTab = types.model(ModelProps).actions(SavedTabActions).views(SavedTabViews);
export default SavedTab;
